// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page-citation {
  display: flex;
  padding: 3px;
  border-radius: 10px;
  justify-content: center;
  font-size: 14px;
  background-color: rgba(10, 15, 41, 0.0784313725);
  font-weight: 500;
}
.landing-page-citation-suggestions-dropdown {
  border: 1px solid var(--border-action-normal, #DEE0E3);
  max-height: 300px;
  overflow: auto;
  position: absolute;
  background: white;
  top: 37px;
  left: 0;
  padding: 10px;
  width: 100%;
  z-index: 10;
  margin-top: 4px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px -2px rgba(20, 21, 26, 0.0509803922);
}
.landing-page-citation-suggestions-dropdown-loading {
  border: 1px solid var(--border-action-normal, #DEE0E3);
  max-height: 400px;
  overflow: auto;
  position: absolute;
  background: white;
  top: 37px;
  left: 0;
  padding: 10px;
  width: 100%;
  font-weight: 400;
  z-index: 10;
  margin-top: 4px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px -2px rgba(20, 21, 26, 0.0509803922);
  font-size: 14px;
  font-style: italic;
}
.landing-page-citation-suggestions-dropdown-item {
  background-color: rgba(10, 15, 41, 0.039);
  border-radius: 5px;
  color: #14151a;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 5px;
  overflow: hidden;
  padding: 0.5rem 0.75rem;
  text-overflow: ellipsis;
}
.landing-page-citation-main {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.landing-page-citation-bar {
  width: 100%;
  display: flex;
}
.landing-page-citation-bar-tab {
  cursor: pointer;
  width: 50%;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
}
.landing-page-citation-bar-tab-field {
  position: relative;
  border: 1px solid var(--border-action-normal, #DEE0E3);
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.0509803922);
  padding: 10px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  display: flex;
}
.landing-page-citation-bar-tab-field input {
  width: 100%;
  background-color: transparent !important;
  border: none !important;
}
.landing-page-citation-bar-tab-field-container {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}
.landing-page-citation-bar-tab-active {
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.0509803922);
  border: 1px solid var(--border-action-normal, #DEE0E3);
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Citation/Citation.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gDAAA;EACA,gBAAA;AAAR;AAEQ;EACI,sDAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,2DAAA;AAAZ;AAEY;EACI,sDAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,2DAAA;EACA,eAAA;EACA,kBAAA;AAAhB;AAGY;EACI,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AADhB;AAKQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAHZ;AAMQ;EACI,WAAA;EACA,aAAA;AAJZ;AAMY;EACI,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAJhB;AAMgB;EACI,kBAAA;EACA,sDAAA;EACA,0DAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;AAJpB;AAMoB;EACI,WAAA;EACA,wCAAA;EACC,uBAAA;AAJzB;AAOoB;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AALxB;AASgB;EACI,0DAAA;EACA,sDAAA;EACA,uBAAA;AAPpB","sourcesContent":[".landing-page {\n    &-citation {\n        display: flex;\n        padding: 3px;\n        border-radius: 10px;\n        justify-content: center;\n        font-size: 14px;\n        background-color: #0A0F2914;\n        font-weight: 500;\n\n        &-suggestions-dropdown {\n            border: 1px solid var(--border-action-normal, #DEE0E3);\n            max-height: 300px;\n            overflow: auto;\n            position: absolute;\n            background: white;\n            top: 37px;\n            left: 0;\n            padding: 10px;\n            width: 100%;\n            z-index: 10;\n            margin-top: 4px;\n            border-radius: 6px;\n            box-shadow: 0px 3px 6px -2px #14151A0D;\n\n            &-loading {\n                border: 1px solid var(--border-action-normal, #DEE0E3);\n                max-height: 400px;\n                overflow: auto;\n                position: absolute;\n                background: white;\n                top: 37px;\n                left: 0;\n                padding: 10px;\n                width: 100%;\n                font-weight: 400;\n                z-index: 10;\n                margin-top: 4px;\n                border-radius: 6px;\n                box-shadow: 0px 3px 6px -2px #14151A0D;\n                font-size: 14px;\n                font-style: italic;\n            }\n\n            &-item {\n                background-color: rgba(10, 15, 41, 0.039);\n                border-radius: 5px;\n                color: #14151a;\n                cursor: pointer;\n                font-size: 14px;\n                font-weight: 400;\n                margin-bottom: 5px;\n                overflow: hidden;\n                padding: 0.5rem 0.75rem;\n                text-overflow: ellipsis;\n            }\n        }\n\n        &-main {\n            display: flex;\n            flex-direction: column;\n            gap: 20px;\n        }\n\n        &-bar {\n            width: 100%;\n            display: flex;\n\n            &-tab {\n                cursor: pointer;\n                width: 50%;\n                text-align: center;\n                padding: 10px;\n                border-radius: 10px;\n\n                &-field {\n                    position: relative;\n                    border: 1px solid var(--border-action-normal, #DEE0E3);\n                    box-shadow: 0px 1px 2px 0px #14151A0D;\n                    padding: 10px;\n                    border-radius: 10px;\n                    font-size: 14px;\n                    font-weight: 500;\n                    justify-content: space-between;\n                    display: flex;\n\n                    & input {\n                        width: 100%;\n                        background-color: transparent !important;\n                         border: none !important;\n                    }\n\n                    &-container {\n                        width: 100%;\n                        display: flex;\n                        align-items: center;\n                        gap: 10px;\n                    }\n                }\n\n                &-active {\n                    box-shadow: 0px 1px 2px 0px #14151A0D;\n                    border: 1px solid var(--border-action-normal, #DEE0E3);\n                    background-color: white;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
